import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { AppHeader } from "../../components/AppHeader";
import { Loading, Empty } from "../../components/Loading";
import { JobCard } from "../../components/JobCard";
import { Search, PackageOpen } from "lucide-react";

const FILTERS = [
  { id: "ALL", label: "All" },
  { id: "ACTIVE", label: "Active" },
  { id: "READY FOR OWNER CHECK", label: "Ready for Check" },
  { id: "COMPLETED", label: "Completed" },
  { id: "BREACHED", label: "Breached" },
  { id: "CANCELLED", label: "Cancelled" },
];

export default function OwnerJobs() {
  const [params, setParams] = useSearchParams();
  const [filter, setFilter] = useState(params.get("filter") || "ALL");
  const [search, setSearch] = useState("");
  const [jobs, setJobs] = useState(null);

  const load = () => {
    setJobs(null);
    api.get("/jobs", { params: { status: filter, search: search || undefined } })
      .then((r) => setJobs(r.data)).catch(() => setJobs([]));
  };
  useEffect(() => { load(); }, [filter]);
  useEffect(() => {
    const t = setTimeout(load, 350);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <>
      <AppHeader title="All Jobs" subtitle="Owner" />
      <div className="px-4 py-4 space-y-4">
        <div className="relative">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <input
            data-testid="owner-job-search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search job number or product…"
            className="w-full h-11 pl-10 pr-4 rounded-xl border border-slate-300 focus:border-[#C86D51] outline-none text-sm bg-white"
          />
        </div>

        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              data-testid={`filter-${f.id}`}
              onClick={() => { setFilter(f.id); setParams({}); }}
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-bold transition-colors ${
                filter === f.id ? "copper-gradient text-white" : "bg-white border border-slate-200 text-slate-600"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {jobs === null ? (
          <Loading />
        ) : jobs.length === 0 ? (
          <Empty icon={PackageOpen} text="No jobs found for this filter." />
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {jobs.map((j) => <JobCard key={j.id} job={j} basePath="/owner/jobs" />)}
          </div>
        )}
      </div>
    </>
  );
}
